import React from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import styled from "styled-components";
import LocationTab from "./LocationTab";
import PlatformTab from "./PlatformTab";

const TabsStyled = styled(Tabs)`
  .selected {
    color: var(--color-brand-pink-primary);
    border-color: var(--color-brand-pink-primary);
    background-color: var(--color-brand-pink-light-selected);
    outline: none;
  }
`;

const TabListStyled = styled(TabList)`
  display: flex;
  padding: 0;
`;

const TabStyled = styled(Tab)`
  border: 1px solid var(--color-toggle-border);
  color: var(--color-toggle-inactive-font);
  font-size: 14px;
  list-style: none;
  padding: 10px 25px;
  border-radius: 10px;
  margin: 5px;
  cursor: pointer;
`;

const ReportGenerateTabs = () => {
  return (
    <TabsStyled selectedTabClassName={"selected"}>
      <TabListStyled>
        <TabStyled className={"location"}>Location</TabStyled>
        <TabStyled className={"platform"}>Platform</TabStyled>
      </TabListStyled>

      <TabPanel>
        <LocationTab />
      </TabPanel>
      <TabPanel>
        <PlatformTab />
      </TabPanel>
    </TabsStyled>
  );
};

export default ReportGenerateTabs;
